<template>
    <div class="side_bar">
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo side_bar_side" router background-color="#6e665f" text-color="#fff" active-text-color="#409eff">
           <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
                <el-menu-item :key="index" :index="item.redirect" >
                    <i :class="item.meta.icon"></i>
                </el-menu-item>
           </template>
        </el-menu>
        <div class="side_bar_det">
          <div class="side_bar_title">
            {{currentTitle}}
          </div>
          <el-menu mode="vertical" unique-opened :default-active="$route.path" class="el-menu-vertical-demo" router background-color="#f1f1f1" text-color="#000" active-text-color="#409eff">
            <template v-for="element in routeChild" v-if="!element.hidden">
              <el-menu-item :key="element.path" :index="element.path" v-if="!element.children">
                  {{element.meta.title}}
              </el-menu-item>
              <el-submenu v-else :key="element.path" :index="element.path">
                <template slot="title">
                  <span>{{element.meta.title}}</span>
                </template>
                <el-menu-item v-for="item in element.children" :key="item.path" :index="item.path" v-if="!item.hidden">
                  {{item.meta.title}}
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </div>
    </div>
</template>
<script>
export default {
  name: "side-bar",
  data() {
    return {
      routeChild: [],
      currentTitle: ""
    };
  },
  created() {
    this.$nextTick(() => {
      this.childSelect();
    });
  },
  updated() {
    this.childSelect();
  },
  methods: {
    childSelect() {
      // console.log(this.$route.path.split("/")[1])
      this.$router.options.routes.forEach(element => {
        if (element.isRoot && element.name.split("-")[0] === this.$route.path.split("/")[1]) {
          this.routeChild = element.children;
          this.currentTitle = element.meta.title;
        }
      });
    }
  },
  watch: {
    $route() {
      this.childSelect();
      // console.log(this.routeChild);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SideBar.vue